<template>
  <nav>
    <div>
      <div v-for="item in menuItems" :key="item.title">
        <div>
          <div>{{ item.icon }}</div>
        </div>
        <div>{{ item.title }}</div>
      </div>
    </div>

    <div class="white--text nav-main-banner o-container">
      <div class="navbar-title o-container-child">
        <img :src="logo" class="logo" />

        <div class="toolbar-items hidden-xs-only">
          <div
            v-for="item in menuItems"
            :key="item.title"
            class="font-weight-regular"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="o-container">
      <div class="white navbar-subtitle o-container-child">
        <span class="subtitle-text">Department of Otolaryngology&nbsp;</span>
        <span class="subtitle-text">Clinical Outcomes Research</span>
      </div>
    </div>
  </nav>
</template>

<script>
import logo from './assets/logo.svg'

export default {
  name: 'Navbar',
  data() {
    return {
      logo,
      appTitle: 'Awesome App',
      sidebar: false,
      menuItems: [
        // { title: 'Home', path: '/home', icon: 'home' },
        // { title: 'Sign Up', path: '/signup', icon: 'face' },
        // { title: 'Sign In', path: '/signin', icon: 'lock_open' },
      ],
    }
  },
}
</script>

<style>
@import './assets/Shared.css';

:root {
  --primary-text: #d01c29;
  --primary: #a51417;
}

nav + * {
  /* whatever comes after this nav, make sure to give it auto margin bottom so it pushes footer to bottom */
  flex-grow: 1;
}

.nav-main-banner {
  background-color: var(--primary);
}

.navbar-title {
  font-size: 16px;
  height: 48px;
  padding: 12px 0px;
  box-sizing: border-box;
}

.navbar-subtitle {
  padding: 12px 0px;
}

.subtitle-text {
  color: var(--primary-text);
  font-family: Source Sans Pro !important;
  font-weight: 700;
}

.toolbar__items .v-btn__content,
.subtitle-text {
  font-size: 14px !important;
  text-transform: uppercase;
  letter-spacing: 0.01em;
  display: inline-block;
}

.navbar-subtitle {
  background-color: white;
}

.logo {
  height: 100%;
  max-width: 100%;
}
</style>
